export default {
    mixed: {
        required: 'Это значение не должно быть пустым',
        oneOf: 'Пароль и подтверждение должны совпадать',
    },
    string: {
        required: 'Это значение не должно быть пустым',
        max: 'Это значение должен содержать не более ${max} символов'
    },
    number: {
        required: 'Это значение не должно быть пустым',
        positive: 'Это значение должен быть положительным',
        integer: 'Это значение состоять из чисел'
    },
    date: {
        required: 'Это значение не должно быть пустым',
        min: 'Это значение должен быть позже ${min}',
        max: 'Это значение должен быть до ${max}'
    },
    array: {
        min: 'Поле должно содержать хотя бы ${min} элемент',
    }
}